function clickedOutside(targetToClose, callback, _excludes = []) {
	const excludes = Array.isArray(_excludes) ? _excludes : [_excludes];
	const $targets = $(targetToClose);

	if (typeof callback !== "function") {
		console.error('Callback has to be a function!');
		return null;
	}

	$('body').on('click', function (e) {
		const clickedElement = e.target;

		$targets.each(function () {
			const $target = $(this);
			const isTargetVisible = $target.is(':visible');
			const isClickedElementExcluded = excludes.some(
				(exclusion) => $(exclusion).is(clickedElement) || $(exclusion).has(clickedElement).length > 0
			);
			const isClickedElementTarget = $target.is(clickedElement);
			const isClickedElementATargetChild = $target.has(clickedElement).length > 0;

			if (
				isTargetVisible &&
				!isClickedElementExcluded &&
				!isClickedElementTarget &&
				!isClickedElementATargetChild
			) {
				callback($target, excludes);
			}
		});
	});
}
